<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Create Leave Type</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Leave Type created successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="leaveTypeForm" #myForm="ngForm" (ngSubmit)="leaveTypeFormSubmit()">

        <mat-form-field *ngIf="isShowOrganization">
            <mat-label>Organizations</mat-label>
            <mat-select formControlName="org_id">
                <mat-option *ngFor="let organization of organizations;" [value]="organization?.org_id">{{organization?.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="leaveTypeFormValidate?.org_id?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Leave Type</mat-label>
            <input type="text" formControlName="leave_type" matInput>
            <mat-error *ngIf="leaveTypeFormValidate?.leave_type?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Description</mat-label>
            <textarea formControlName="leave_type_desc" matInput cols="30" rows="3"></textarea>
            <mat-error *ngIf="leaveTypeFormValidate?.leave_type_desc?.errors?.required">This field is required.</mat-error>
        </mat-form-field>


        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue">Create </button>
            </div>
        </div>
    </form>
</div>